module.exports = __webpack_public_path__ + "static/media/compass-slash.11177dd1.svg";